export const enum Status {
  Active = "ACTIVE",
  Pending = "PENDING",
  Inactive = "INACTIVE",
  PendingReview = "PENDING_REVIEW",
  Declined = "DECLINED",
  InReview = "IN_REVIEW",
}
